const PLACEHOLDER_EMAIL_DOMAIN = '@noemail.waterlily.internal';
const SAMPLE_CLIENT_EMAIL_DOMAIN = '@waterlily.internal';

export function isPlaceholderEmail(email: string | undefined | null): boolean {
  return !!email && (email.endsWith(PLACEHOLDER_EMAIL_DOMAIN) || email.endsWith(SAMPLE_CLIENT_EMAIL_DOMAIN));
}
